import { render, staticRenderFns } from "./ServiceVendors.vue?vue&type=template&id=b04da86a&"
import script from "./ServiceVendors.vue?vue&type=script&lang=js&"
export * from "./ServiceVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports